module.exports = __webpack_public_path__ + "img/paqueteria.5e049e77.png";